/* istanbul ignore file */

import Component from './component'
export default Component
